import { IsDefined, IsString, MinLength } from 'class-validator';

export class KladrSuggestionsRequest {
    @IsString()
    @IsDefined()
    @MinLength(2)
    public query: string;

    constructor(data?: Partial<KladrSuggestionsRequest>) {
        this.query = data?.query?.trim();
    }
}
